@if (flashCard) {
  @if (flashCard?.image?.uri) {
    <figure
      class="flashcard__figure"
      aria-hidden="true">
      <img class="flashcard__image"
        [src]="flashCard?.image?.uri"
        [alt]="flashCard?.image?.alt">
        @if (!flashCard?.audio?.uri || (flashCard?.audio?.uri && !showTitleOnlyIfNoAudio)) {
          <figcaption
            class="flashcard__caption">
            {{ flashCardTitle }}
          </figcaption>
        }
      </figure>
    }
    <!--only for audio description-->
    @if (!flashCard?.audio?.uri || (flashCard?.audio?.uri && !showTitleOnlyIfNoAudio)) {
      <div
        class="flashcard__audio-description"
        [attr.aria-live]="readTitle ? 'assertive' : 'off'">
        {{readTitle?flashCardTitle:''}}
      </div>
    }
    @if (flashCard?.audio?.uri) {
      <audio
        class="flashcard__audio"
        #stream
        controls
        [attr.id]="flashCard?.audio?.id"
        [attr.src]="flashCard?.audio?.uri"
        [attr.aria-label]="flashCard?.audio?.alt">
        Your browser does not support the <code>audio</code> element.
      </audio>
    }
  }